import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import ResponsiveHOC from "../../HOC/components/responsive";
import { xssFilter } from "../../common/utils/xssFilter";

class ExpertInfoSection extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            paragraphDisplay: ["S", "M"].includes(this.props.size) ? "none" : "",
            isExpanded: false
        };

        this.toggleDisplay = this.toggleDisplay.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
    }

    componentDidUpdate() {
        if (["S", "M"].includes(this.props.size)) {
            if (this.state.isExpanded) return;
            this.setState({ paragraphDisplay: "none" });
        } else {
            this.setState({
                paragraphDisplay: "",
                isExpanded: false
            });
        }
    }

    onLinkClick(actions = []) {
        if (actions.length) {
            return this.props.dispatchSirenActions(
                [...actions],
                this.props.widgetId,
                this.props.computedBindTo,
                ["default"]
            );
        }
    }

    toggleDisplay() {
        this.setState({
            paragraphDisplay: this.state.paragraphDisplay === "none" ? "" : "none",
            isExpanded: !this.state.isExpanded
        });
    }

    render() {
        const dataEntity = EntityBuilder.of(this.props.data, { inplace: true });
        let tagsLength;
        let subtitleSectionEntity;
        if (dataEntity.getId() === "folder") {
            tagsLength = dataEntity.getChild("folder.article.tags").getChildren().length;
            subtitleSectionEntity = dataEntity.getChild("folder.article.subtitleSection");
        } else {
            subtitleSectionEntity = dataEntity.getChild("article.subtitleSection");
            tagsLength = dataEntity.getChild("article.tags").getChildren().length;
        }
        const text = subtitleSectionEntity.getChild("text").getValue();
        const link = subtitleSectionEntity.getChild("link");
        const linkLabel = link.getLabel();
        const linkActions = link.getActions();
        const leftImageEntity = subtitleSectionEntity.getChild("leftImage");
        const leftImageSrc = leftImageEntity.getProperty("src");
        const leftImageAlt = leftImageEntity.getProperty("alt");
        const rightImageEntity = subtitleSectionEntity.getChild("rightImage");
        const rightImageSrc = rightImageEntity.getProperty("src");
        const rightImageAlt = rightImageEntity.getProperty("alt");
        const paragraphStyle = {
            display: this.state.paragraphDisplay
        };
        const childrenRegions = this.resolveRegions();
        const btnExpanded = this.state.isExpanded === true ? "tq-expanded" : "";
        const buttonClassName = `tq-section tq-expandable ${btnExpanded}`;
        const lineSeparator =
            tagsLength > 0 && ["S", "M"].includes(this.props.size)
                ? true
                : !!(leftImageSrc || text || rightImageSrc);
        const showAccordion = childrenRegions.content || text || linkLabel;
        const hasData = showAccordion || leftImageSrc || rightImageSrc;
        if (!hasData) {
            return this.getEmptyContent();
        }
        return (
            <div>
                <div className={`${showAccordion ? "tq-accordion " : ""}un-info-accordion`}>
                    <div
                        onClick={() => (showAccordion ? this.toggleDisplay() : {})}
                        className={buttonClassName}
                    >
                        <div className={`${showAccordion ? "tq-section-header" : ""}`}>
                            <div className="tq-splitbox">
                                <div className="tq-splitbox-primary">{childrenRegions.header}</div>
                            </div>
                        </div>
                        {childrenRegions.content}
                    </div>
                </div>
                <div className="tq-flex-container un-items-center un-logo-and-content">
                    {leftImageSrc && (
                        <div className="tq-flex-item un-logo-item">
                            <span className="tq-image">
                                <img src={leftImageSrc} alt={leftImageAlt} />
                            </span>
                        </div>
                    )}
                    <div
                        style={paragraphStyle}
                        className="tq-flex-item un-logo-content-text un-logo-content-info"
                    >
                        <div>
                            {text && (
                                <div className="tq-bold tq-neutral-color-1">
                                    <p
                                        className="tq-paragraph"
                                        dangerouslySetInnerHTML={{
                                            __html: xssFilter.process(text)
                                        }}
                                        data-hyperlinks-container={true}
                                    />
                                </div>
                            )}
                            {linkLabel && (
                                <a
                                    onClick={() => {
                                        this.onLinkClick(linkActions);
                                    }}
                                    className={"tq-neutral-color-2"}
                                >
                                    {linkLabel}
                                </a>
                            )}
                        </div>
                    </div>
                    {childrenRegions.tags}
                    {rightImageSrc && (
                        <div className="tq-flex-item un-logo-item un-logo-item-sm">
                            <span className="tq-image">
                                <img src={rightImageSrc} alt={rightImageAlt} />
                            </span>
                        </div>
                    )}
                    <div className="tq-flex-item un-end-line">
                        {lineSeparator && <div className="tq-line-separator" />}
                    </div>
                </div>
            </div>
        );
    }
}

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(ResponsiveHOC(ExpertInfoSection, { sizes: { S: 0, M: 481, L: 1201, XL: 1680 } }));
